import { LatLng } from 'leaflet';
import { IUndoRedoCommand } from './undoRedoCommand';

interface IAddVerticesCommand extends IUndoRedoCommand {
  addVertex(latlng: LatLng): void;
}

export abstract class AddVerticesCommandBase implements IAddVerticesCommand {
  public latlng: LatLng[] = [];

  constructor(latlng: LatLng) {
    this.latlng.push(latlng);
  }

  addVertex(latlng: LatLng): void {
    this.latlng.push(latlng);
  }

  abstract executeUndo(): void;

  abstract executeRedo(): void;
}
